module.exports = __webpack_public_path__ + "static/media/PDF_125.c89129f3.pdf";